import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import { SearchFilterComparisonOperator } from "hooks/search/types";
import { Controller } from "react-hook-form";

interface ComparisonOperatorDropdownProps {
  name: string;
}

export const ComparisonOperatorDropdown = ({
  name,
}: ComparisonOperatorDropdownProps) => {
  const { t } = useTranslation(["books"]);

  const comparisonTypeTranslations = {
    [SearchFilterComparisonOperator.GREATER]: t(
      "books:filter.keywordTypes.greater",
    ),
    [SearchFilterComparisonOperator.LESS]: t("books:filter.keywordTypes.less"),
    [SearchFilterComparisonOperator.EQUALS]: t(
      "books:filter.keywordTypes.equals",
    ),
  } satisfies Record<SearchFilterComparisonOperator, string>;

  return (
    <span className="whitespace-nowrap">
      <Controller
        name={name}
        defaultValue={SearchFilterComparisonOperator.GREATER}
        render={({ field }) => (
          <Select value={field.value} onValueChange={(v) => field.onChange(v)}>
            <SelectTrigger className="h-full border-secondary-300 rounded-[8px] rounded-e-none bg-secondary-25 min-w-28 group-focus-within:border-0 group-focus-within:border-r focus-visible:ring-0">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="rounded-[8px] z-[80]">
              <SelectGroup>
                {Object.entries(SearchFilterComparisonOperator).map(
                  ([key, operator]) => (
                    <SelectItem
                      key={key}
                      value={operator}
                      analytics-id="button_keyword_filter_type"
                      className="text-sm focus:!bg-secondary-25"
                    >
                      {comparisonTypeTranslations[operator]}
                    </SelectItem>
                  ),
                )}
              </SelectGroup>
            </SelectContent>
          </Select>
        )}
      />
    </span>
  );
};
